module.exports = ".kan-mail-template-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/mails/dialogs/mail-template-dialog/component.scss
// module id = ./src/modules/mails/dialogs/mail-template-dialog/component.scss
// module chunks = main